import { Button } from "@acme/ui/button";
import { LuPlay } from "react-icons/lu";
import CustomCommandButton from "./CommandModal";

interface RunButtonProps {
	onClick: () => void;
}

export const RunButton: React.FC<RunButtonProps> = ({ onClick }) => {
	return (
		<>
			<Button onClick={onClick}>
				<LuPlay />
				Run
			</Button>
			<CustomCommandButton />
		</>
	);
};
